﻿import { opaccAjaxPlugin } from "./vendor/script/opacc.static.js";

export class AdditionalBasketActions {
    constructor() {
        this.additionalAreaSelector = '[data-additional-area]';
        this.forFreeCeckboxSelector = '[data-cb-for-free]';
        this.attachEventListener();
    }

    attachEventListener() {
        const additionalArea = document.querySelector(this.additionalAreaSelector);

        if(!additionalArea) return;
        
        additionalArea.addEventListener("click", (e) => {
            if(e.target.closest(this.forFreeCeckboxSelector)) {
                // on cb for free clicked

                // get checkbox url for async request
                const checkboxUrl = e.target.dataset.cbUrl;

                if(!checkboxUrl) return;

                let dataToPass = {
                    artIsForFree: !!e.target.checked ? 1 : 0
                };

                opaccAjaxPlugin.fetchAsynPostForm(checkboxUrl,dataToPass ,(result) => {
                    // result contains info about free item -> log?
                });

            }else if(e.target.closest("[data-delete-me]")) {
                console.log("btn clicked");
            }else {
                // Nothing clicked
            }
        });
    }
}

